import { render, staticRenderFns } from "./PremiumCandle.vue?vue&type=template&id=e595fd04&scoped=true"
import script from "./PremiumCandle.vue?vue&type=script&lang=js"
export * from "./PremiumCandle.vue?vue&type=script&lang=js"
import style0 from "./PremiumCandle.vue?vue&type=style&index=0&id=e595fd04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e595fd04",
  null
  
)

export default component.exports